import React from "react";
import PropTypes from "prop-types";

import Message from "./Message";
import moment from 'moment'

class Messages extends React.Component {
	sortByDateDesc(m1, m2) {
		if (moment(m1.date).isBefore(moment(m2.date))) return 1;

		if (moment(m1.date).isAfter(moment(m2.date))) return -1;

		return 0;
	}

	render() {
		// Loop through all the messages in the state and create a Message component
		const messages = this.props.messages.sort(this.sortByDateDesc).map((message, i) => {
			return <Message key={i} message={message} />;
		});

		return (
			<div className="messages" id="messageList">
				{messages}
			</div>
		);
	}
}

Messages.propTypes = {
	messages: PropTypes.array.isRequired,
};

Messages.defaultProps = {
	messages: [],
};

export default Messages;
